// extracted by mini-css-extract-plugin
module.exports = {"switcherWrapper":"purpose-switcher_switcherWrapper__rirX2"};